import { PathSolver } from 'my-account-common'

class Config {
  constructor () {
    let envPath = PathSolver.getPathForWebEnvironment()
    if (envPath === '') {
      envPath = 'www'
    }
    //  Datapower endpoints for this module
    this.loginEndPoint = 'https://webservice' + PathSolver.getPathForEnvironment() + '.24hourfitness.com/api/rest/myaccount-login-process/login'
    //  Temporary urls for testing purposes
    this.defaultURI = 'https://' + envPath + '.24hourfitness.com/myaccount/profile.html'
    //  URL for forgot credentials and registration
    this.forgotCredentialsUrl = 'https://' + envPath + '.24hourfitness.com/forgotCredentials.html'
    this.registrationUrl = 'https://' + envPath + '.24hourfitness.com/registration.html'
  }
}
let cfg = new Config()
export default cfg



// WEBPACK FOOTER //
// ./src/services/configuration/PropertiesConfiguration.js